<template>
  <v-layout row wrap>
    <vue-title v-if="data" :title="data.firstName + ' ' + data.lastName" />
    <v-flex xs12 md5>
      <v-layout column>
        <v-flex ma-2>
          <FCCCompetitorDetails v-if="data" :dataProp="this.data" :reload="this.reload" />
        </v-flex>
        
      </v-layout>
    </v-flex>
    <v-flex xs12 md7>
      <v-layout column>
        <v-flex ma-2>
          <FCCCompetitorApplications />
        </v-flex>
        <v-flex ma-2>
          <FCCCompetitorCheckIns v-if="data" :data="this.data" />
        </v-flex>
        <v-flex ma-2>
          <FCCCompetitorRoles v-if="data && $store.getters['isAdministrator']" :data="this.data" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import fccapi from '../fccapi.js'
  import FCCCompetitorDetails from '../components/competitor/FCCCompetitorDetails'
  import FCCCompetitorApplications from '../components/competitor/FCCCompetitorApplications'
  import FCCCompetitorCheckIns from '../components/competitor/FCCCompetitorCheckIns'
  import FCCCompetitorRoles from '../components/competitor/FCCCompetitorRoles'

  export default {
    name: 'Competitor',
    data: () => ({
      drawer: null,
      dateofbirth: "",
      data: null
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    methods: {
      reload: function(){
        fccapi.get('competitors/'+this.$route.params.id).then((r) => {
          this.data = r.data;
        })
      }
    },
    props: {
      source: String
    },
    components: {
      FCCCompetitorDetails,
      FCCCompetitorApplications,
      FCCCompetitorCheckIns,
      FCCCompetitorRoles
    },
    mounted() {
      this.reload();
    }
  }
</script>